(function() {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('perfil', {
            parent: 'app',
            url: '/perfil',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/perfil/perfil.html',
                    controller: 'PerfilController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
